import createVueComponent from '../createVueComponent';

const ArrowUpToLine = createVueComponent('ArrowUpToLineIcon', [
  ['path', { d: 'M5 3h14', key: '7usisc' }],
  ['path', { d: 'm18 13-6-6-6 6', key: '1kf1n9' }],
  ['path', { d: 'M12 7v14', key: '1akyts' }],
]);

export default ArrowUpToLine;
